// قاب صفحات عمومی PLT (AP-PLT-07): نام محصول یا مرکز، عنوان و شناسه صفحه.
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { useEffect, type ReactNode } from 'react';

export function PublicShell({ screenId, titleKey, name, children }: { screenId: string; titleKey: string; name?: string; children: ReactNode }) {
  const { t } = useTranslation('plt');
  useEffect(() => {
    document.title = `${t(titleKey)} · ${t('shell:app.staff_name')}`;
  }, [t, titleKey]);
  return (
    <Box data-screen-id={screenId} sx={{ minHeight: '100vh', bgcolor: 'background.default', p: { xs: 1.5, sm: 3 } }}>
      <Paper variant="outlined" component="main" sx={{ p: { xs: 2, sm: 4 }, maxWidth: 560, mx: 'auto' }}>
        <Stack direction="row" spacing={1} sx={{ mb: 2, alignItems: 'center' }}>
          <LocalHospitalOutlinedIcon color="primary" />
          <Typography sx={{ fontWeight: 600 }} data-testid="public-tenant-name">
            {name ?? t('shell:app.staff_name')}
          </Typography>
        </Stack>
        <Typography variant="h1" sx={{ mb: 2 }}>
          {t(titleKey)}
        </Typography>
        {children}
      </Paper>
    </Box>
  );
}
